import { z } from "zod"

export const contactSchema = z.object({
  email: z
    .string()
    .min(1, "Email é obrigatório")
    .email("Email inválido"),

  phone: z
    .string()
    .min(1, "Telefone é obrigatório")
    .refine(
      (value) => !/<[^>]*>/g.test(value),
      "Telefone contém caracteres inválidos"
    ),

  message: z
    .string()
    .min(1, "Mensagem é obrigatória")
    .min(3, "Mensagem muito curta"),
})

export type ContactFormData = z.infer<typeof contactSchema>
